import React, {useState} from 'react';
import classes from "./SearchBar.module.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch} from '@fortawesome/free-solid-svg-icons';
import db from "../../data/firebase";
import Spinner from 'react-bootstrap/Spinner';


function SearchBar(props){
  const [perfumes, setPerfumes]= useState();
  const [searchedValue, setSearchedValue]=useState("");

  
  let perfumeList=[];
  let newLink=null;//"/desc/?perfume="+props.id;

  


  
  function checking(){
    let i=0;
    db.collection("perfumes").get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            
            let temp={
                id: doc.id,
                data: doc.data(),
            }
            perfumeList[i]=temp;
         
            
            i++;
            
        });
        setPerfumes(perfumeList);

    });
}







 
    return(
      <div>
       {perfumes ? null :checking()}
       
      
              <input
                className={classes.BarStyle}
                key="random1"
                // value={props.keyword}
                placeholder="Search"
                onChange={event=> setSearchedValue(event.target.value)}
                />
                <FontAwesomeIcon icon={faSearch}  className={classes.icon}/>

                <div >
                  {perfumes ? perfumes.filter((val)=>{
                    if (searchedValue == ""){
                      return null;
                    }
                    else if (val.data.name.toLowerCase().includes(searchedValue.toLowerCase())){
                      return val;
                    }
                  }).map((val) =>{
                    {newLink="/desc/?perfume="+val.id}
                    return (
                      <div className={classes.searchBox}>
                        
                        
                       <a className={classes.links} href= {newLink}><p>{val.data.name}</p></a> <hr/>
                      </div>
                      )
                  }) : null}
              
                 
                  
                  


                </div>

      
      
      </div>
               


        
      
    )
}

export default SearchBar;